/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_TilInputs */

const en_mapping_system_til = /** @type {(inputs: Mapping_System_TilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TIL`)
};

/**
* | output |
* | --- |
* | "TIL" |
*
* @param {Mapping_System_TilInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_til = /** @type {((inputs?: Mapping_System_TilInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_TilInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_til(inputs)
});